var React = require('react');

function OtherIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.895 10.858a6.406 6.406 0 0 1 9.023 0l2.312 2.294 2.312-2.294a6.406 6.406 0 0 1 9.023 9.096L20.23 31.2 8.895 19.954a6.406 6.406 0 0 1 0-9.096zm7.615 1.42a4.406 4.406 0 1 0-6.207 6.257l9.927 9.847 9.927-9.848a4.406 4.406 0 1 0-6.207-6.256l-2.582 2.561a1.617 1.617 0 0 1-2.277 0l-2.581-2.56z","fill":"#fff"}));
}

OtherIcon.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = OtherIcon;

OtherIcon.default = OtherIcon;
